import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    congregateDirection;
    enableScatterAnalyze;
    disabled;
    formData = {
        enableScatterAnalyze: this.$props.enableScatterAnalyze,
        congregateDirection: this.$props.congregateDirection,
    };
    changeCongregateDirection(val) {
        this.$emit('update:congregateDirection', val);
    }
    changeTrigerMode(val) {
        this.$emit('update:enableScatterAnalyze', val);
    }
    isValidate() {
        return true;
    }
};
__decorate([
    Prop()
], default_1.prototype, "congregateDirection", void 0);
__decorate([
    Prop()
], default_1.prototype, "enableScatterAnalyze", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'Mode',
        components: {},
        i18n: {
            messages: {
                zh: {
                    triger: '告警触发方式',
                    bothTriger: '聚集告警&分散告警',
                    gather: '仅聚集告警',
                    alert: '告警模式',
                    bothAlert: '同心 & 同向',
                    concentric: '同心',
                    direction: '同向',
                },
                'en-us': {
                    triger: 'Trigger Mode',
                    bothTriger: 'Gather & Spread',
                    gather: 'Gather',
                    alert: 'Alert Mode',
                    bothAlert: 'Concentric&Same Direction',
                    concentric: 'Concentric',
                    direction: 'Same Direction',
                },
            },
        },
    })
], default_1);
export default default_1;
